var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import _ from 'lodash';
export default class ShopamineAPI {
    constructor(url) {
        this.update_config = (config, override = false) => {
            if (override) {
                //overrides the config
                this.config = config;
                return this.axios = axios.create(config);
            }
            if (!this.config) {
                this.config = config;
            }
            const newConfig = _.merge(this.config, config);
            this.config = newConfig;
            return this.axios = axios.create(newConfig);
        };
        this.doRequestPost = (url, data) => __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.axios.post(`/api/v1${url}`, data);
                return res.data;
            }
            catch (eRaw) {
                const e = eRaw;
                if (e.response && e.response.data) {
                    console.error(e);
                    throw new Error(e.response.data.errMsg);
                }
                else if (e.response) {
                    console.error(e);
                    throw new Error(e.message);
                }
                else if (e.message) {
                    console.error(e);
                    throw new Error(e.message);
                }
                else {
                    console.error(e);
                    throw e;
                }
            }
        });
        this.session = (sessionReq) => __awaiter(this, void 0, void 0, function* () {
            return this.doRequestPost(`/check/session`, sessionReq);
        });
        this.check_domain = (domainPart) => __awaiter(this, void 0, void 0, function* () {
            return this.doRequestPost(`/check/domain`, {
                domainPart
            });
        });
        this.check_session = () => __awaiter(this, void 0, void 0, function* () {
            return this.doRequestPost(`/validate/session`, {});
        });
        this.get_login_link = (data) => __awaiter(this, void 0, void 0, function* () {
            return this.doRequestPost(`/login`, data);
        });
        this.create_store = (createStoreRequest) => __awaiter(this, void 0, void 0, function* () {
            return this.doRequestPost(`/create`, createStoreRequest);
        });
        this.check_create_status = () => __awaiter(this, void 0, void 0, function* () {
            return this.doRequestPost(`/check/creating`, {});
        });
        this.get_domains = (storeId) => __awaiter(this, void 0, void 0, function* () {
            return this.doRequestPost(`/domains`, { storeId });
        });
        this.get_stores = () => __awaiter(this, void 0, void 0, function* () {
            return this.doRequestPost(`/stores`, {});
        });
        this.url = url;
        this.axios = this.update_config({
            baseURL: url,
            timeout: 15000,
            headers: {
                'Content-Type': "application/json"
            }
        }, true);
    }
}
